import { Box, Grid, Hidden, Stack, Typography, useTheme, useMediaQuery, Drawer, IconButton, Button, CircularProgress, Dialog, DialogContent, DialogActions } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import Images from '../../../utils/Images';
import { useLocation, useNavigate } from 'react-router-dom';
import { CloseOutlined, KeyboardArrowRight, KeyboardArrowRightSharp, ShoppingCartOutlined } from '@mui/icons-material';
import StoreHeader from '../../../components/StoreHeader';
import SortByComponent from '../../../components/SortByComponent';
import { API } from '../../../utils/Api';
import axios from 'axios';
import ProductCard from '../../../components/ProductCard';
import { useDispatch, useSelector } from 'react-redux';
import { useSocket } from '../../../context/SocketContext';
import { setSearchText } from '../../../store/Search/SearchSlice';
import ProductDrawer from '../../../components/ProductDrawer';
import toast from 'react-hot-toast';

const SubscriptionMenu = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { sub } = location.state || {};
    const [outletData, setOutletData] = useState(JSON.parse(localStorage.getItem('selectedStoreData')));
    const token = localStorage.getItem("token");
    const dispatch = useDispatch();
    const socket = useSocket();
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [activeCategory, setActiveCategory] = useState(categories[0]?._id);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const outlet = localStorage.getItem("selectedStoreData");
    const deliveryType = localStorage.getItem("selectedOrderType");
    const ordersType = localStorage.getItem("selectedOrderType");
    const outletObject = JSON.parse(outlet);
    const outletId = outletObject?._id;
    const [quantity, setQuantity] = useState(1);
    const searchText = useSelector(state => state?.search?.searchText);
    const theme = useTheme();
    const matchesMdUp = useMediaQuery(theme.breakpoints.up('md'));
    const [selectedAddons, setSelectedAddons] = useState({});
    const [addingToCart, setAddingToCart] = useState(false);
    const [fetchingProducts, setFetchingProducts] = useState(true);
    const matchesMobile = useMediaQuery(theme.breakpoints.up('md'));
    const containerRef = useRef(null);
    const [orderItems, setOrderItems] = useState(2);
    const [showLimitModal, setShowLimitModal] = useState(false);
    const getCartKey = (subId) => `localCart_${subId}`;
    const categoryRefs = useRef([]);
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('userDataLogin')));
    const [localCart, setLocalCart] = useState(() => {
        // const saved = localStorage.getItem('localCart');
        const saved = localStorage.getItem(getCartKey(sub?._id));
        return saved ? JSON.parse(saved) : [];
    });

    const getCategoriesList = async () => {
        // if (!outletData?._id) return;
        // setFetchingProducts(true);
        try {
            const response = await axios.get(
                `${API.BASE_URL}subscription-product/${userData?._id}?_id=${sub?._id}&search=${searchText}`,
                {
                    headers: token ? { Authorization: `Bearer ${token}` } : {},
                }
            );
            let fetchedCategories = response?.data?.data?.categories;
            if (outletData?.isEventOutlet) {
                fetchedCategories = fetchedCategories.sort((a, b) => {
                    return (b.isEventCategory ? 1 : 0) - (a.isEventCategory ? 1 : 0);
                });
            }
            setCategories(fetchedCategories);
            console.log('categories', fetchedCategories);
        } catch (error) {
            console.error('Error:', error);
        } finally {
            // setFetchingProducts(false);
        }
    };

    const handleCloseModal = () => {
        setSelectedProduct(null);
        setQuantity(1);
        setSelectedAddons({});
    };

    const handleProductClick = (product) => {
        setSelectedProduct(product);
        console.log('Product', product);
    };

    const validateAddonsBeforeAddToCart = () => {
        const invalidAddonTitles = [];

        selectedProduct?.addons?.forEach((addon) => {
            const hasDefaultExcluded = addon?.values?.some(
                (val) => val?.isDefault && val?.excludedOutlets?.includes(outletData?._id)
            );

            const hasDefaultInactive = addon?.values?.some(
                (val) => val?.isDefault && val?.status === 'INACTIVE'
            );

            const selected = selectedAddons[addon?._id];

            let isInvalid = false;

            if (addon?.isMultipleSelect) {
                isInvalid =
                    (hasDefaultExcluded || hasDefaultInactive) &&
                    (!Array.isArray(selected) || selected.length === 0);
            } else {
                isInvalid =
                    (hasDefaultExcluded || hasDefaultInactive) &&
                    (!selected ||
                        selected?.excludedOutlets?.includes(outletData?._id) ||
                        selected?.status === 'INACTIVE');
            }

            if (isInvalid) {
                invalidAddonTitles.push(addon?.title);
            }
        });

        if (invalidAddonTitles?.length > 0) {
            toast.error(
                `Please select other available options for: ${invalidAddonTitles?.join(', ')}`
            );
            return false;
        }

        return true;
    };

    const handleAddonSelect = (addonId, addonValue, isMultipleSelect = false) => {
        setSelectedAddons((prevSelectedAddons) => {
            if (isMultipleSelect) {
                const currentSelections = Array.isArray(prevSelectedAddons[addonId]) ? prevSelectedAddons[addonId] : [];
                const isAlreadySelected = currentSelections.some(
                    (selected) => selected._id === addonValue._id
                );
                const updatedSelections = isAlreadySelected
                    ? currentSelections.filter((selected) => selected._id !== addonValue._id) : [...currentSelections, addonValue];
                // console.log('updatedSelections', updatedSelections);
                return {
                    ...prevSelectedAddons,
                    [addonId]: updatedSelections,
                };
            } else {
                const isSelected = prevSelectedAddons[addonId]?._id === addonValue?._id;
                const isDefault = addonValue?.isDefault;
                if (isSelected && !isDefault) {
                    const updatedAddons = { ...prevSelectedAddons };
                    delete updatedAddons[addonId];
                    return updatedAddons;
                }
                return {
                    ...prevSelectedAddons,
                    [addonId]: addonValue,
                };
            }
        });
    };

    const subscriptionLimit = () => {
        if (localCart.reduce((sum, item) => sum + (item.quantity || 1), 0) >= sub?.orderQuantity) {
            setShowLimitModal(true);
        }
    };

    const addToLocalCart = (product) => {
        if (localCart.reduce((sum, item) => sum + (item.quantity || 1), 0) >= sub?.orderQuantity) {
            setShowLimitModal(true);
            handleCloseModal();
            return;
        }
        const selectedAddonValues = [];

        if (product?.hasAddon && product?.addons?.length > 0) {
            product.addons.forEach((addon) => {
                const selection = selectedAddons[addon._id];

                if (addon.isMultipleSelect) {
                    if (Array.isArray(selection)) {
                        selectedAddonValues.push(...selection);
                    }
                } else {
                    if (selection) {
                        selectedAddonValues.push(selection);
                    } else {
                        const defaultVal = addon.values?.find(v => v?.isDefault);
                        if (defaultVal) selectedAddonValues.push(defaultVal);
                    }
                }
            });
        }

        const newProduct = {
            ...product,
            selectedAddons: selectedAddonValues,
            quantity: 1,
            addedAt: Date.now(),
        };

        setLocalCart(prevCart => {
            const existingIndex = prevCart.findIndex((item) =>
                item._id === newProduct._id &&
                JSON.stringify(item.selectedAddons?.map(a => a._id).sort()) === JSON.stringify(newProduct.selectedAddons?.map(a => a._id).sort())
            );

            let updatedCart;
            if (existingIndex > -1) {
                updatedCart = [...prevCart];
                updatedCart[existingIndex].quantity = (updatedCart[existingIndex].quantity || 1) + 1;
            } else {
                if (prevCart.length >= orderItems) {
                    setShowLimitModal(true);
                    return prevCart;
                }
                updatedCart = [...prevCart, newProduct];
            }

            localStorage.setItem(getCartKey(sub?._id), JSON.stringify(updatedCart));
            toast.success('Item added to cart');
            setSelectedProduct(null);
            return updatedCart;
        });
    };

    const [activeCategoryId, setActiveCategoryId] = useState(null);

    const handleCategoryClick = (categoryId, index) => {
        setActiveCategoryId(categoryId);
        if (categoryRefs.current[index]) {
            categoryRefs.current[index].scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    useEffect(() => {
        if (categories.length > 0) {
            setActiveCategoryId(categories[0]._id);
        }
    }, [categories]);

    useEffect(() => {
        getCategoriesList();
        subscriptionLimit();
        console.log('Sub menu', sub);
    }, []);

    useEffect(() => {
        getCategoriesList();
    }, [searchText]);

    useEffect(() => {
        return () => {
            dispatch(setSearchText(''));
        };
    }, [dispatch]);

    return (
        <Box className="subscriptionMenu">
            {/* <Stack direction={'row'} sx={{ my: 2, mb: 0, px: 3, background: 'linear-gradient(to right, #FDFF7D, #FFFED9)', borderRadius: '40px', width: 'fit-content', alignItems: 'center', alignSelf: 'center', justifySelf: 'center' }}>
                <Box sx={{ display: 'flex' }}>
                    <Typography fontWeight={'600'} color={'#0ED511'}>Active Plan</Typography>
                    <Typography fontWeight={'600'} color={'#0E4961'} px={1}>: {sub?.remainingDays} days remaining</Typography>
                </Box>
                <img src={Images.activePlanBird} />
            </Stack> */}

            <Box pt={2} className="subscriptionPlan">
                <img src={sub?.banner_imageUrl} style={{ width: '100%' }} />
                <Typography className='planName'>{sub?.title}</Typography>
                <Typography variant='caption' color={'#A5A5A5'} onClick={() => navigate('/subscriptionPurchase')}>See details</Typography>
            </Box>

            <Hidden mdUp>
                <StoreHeader />
            </Hidden>

            <Box className="imageCategories" pt={3} pb={1}>
                <Box className="imageCategoryContainer">
                    {categories?.slice().sort((a, b) => {
                        if (outletData.isEventOutlet) {
                            return (b.isEventCategory ? 1 : 0) - (a.isEventCategory ? 1 : 0) || a.sequenceNumber - b.sequenceNumber;
                        }
                        return a.sequenceNumber - b.sequenceNumber;
                    })
                    .filter(category => outletData.isEventOutlet || !category.isEventCategory || !category?.excludedOutlets?.includes(outletData?._id))
                    .map((category, index) => (
                        <Box className="img-grid" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Typography className="categoryName">{category?.name}</Typography>
                            <Box key={category?._id} onClick={() => handleCategoryClick(category?._id, index)} className={`imageBox ${activeCategoryId === category._id ? 'active' : ''}`}>
                                <img className="image" src={category?.displayImage} alt="product" />
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>
            <Box className="productsListing">
                <Grid ref={containerRef} container>
                    {categories?.filter(category => outletData.isEventOutlet || !category.isEventCategory || !category?.excludedOutlets?.includes(outletData?._id)).map((category, index) => {
                        let totalProductsRendered = 0;
                        const totalProducts = category?.products?.length;
                        let productsPerRow = 3;
                        const showCategoryTopImage = outletData?.isEventOutlet || (!outletData?.isEventOutlet && !category?.isEventCategory);
                        return (
                            <Grid container key={category?._id} ref={el => categoryRefs.current[index] = el}>
                                {showCategoryTopImage && (
                                    <Grid md={12}>
                                        <img className="categoryTopImage" src={category?.bannerImage} alt={category?.name} />
                                    </Grid>
                                )}
                                {category?.products.slice()
                                    .filter(product => !product?.excludedOutlets?.includes(outletData?._id))
                                    .sort((a, b) => {
                                        if (a.isExhausted && !b.isExhausted) return 1;
                                        if (!a.isExhausted && b.isExhausted) return -1;
                                        return a.sequenceNumber - b.sequenceNumber;
                                    })
                                    .map((product, productIndex) => {
                                        const rowPosition = Math.floor(productIndex / productsPerRow);
                                        const colPosition = productIndex % productsPerRow;
                                        const isLastRow = (Math.ceil(totalProducts / productsPerRow) - 1) === rowPosition;
                                        const isLastInRow = colPosition === (productsPerRow - 1) || productIndex === (totalProducts - 1);
                                        const isFirstInRow = colPosition === 0;
                                        return (
                                            <>
                                                <Grid item sm={12} md={4} key={product?._id}>
                                                    <Box key={product?._id}
                                                        sx={{
                                                            ...(matchesMdUp ? { borderRight: isLastInRow ? 'none' : '1px dashed #D6D6D6' } : { borderRight: 'none', borderLeft: 'none', }),
                                                            borderBottom: isLastRow ? 'none' : '1px dashed #D6D6D6',
                                                            ...(matchesMdUp ? {} : {
                                                                borderBottom: isLastRow ? 'none' : '1px dashed #D6D6D6',
                                                            }),
                                                        }}
                                                        className={`product-item ${product?.isExhausted ? 'exhausted' : ''}`}
                                                    >
                                                        <Grid container onClick={() => handleProductClick(product)}>
                                                            <Grid item xs={4} sm={4} className="imageBox" onClick={() => handleProductClick(product)}>
                                                                <img className="image" src={product?.displayImageUrl} alt="Product" />
                                                            </Grid>
                                                            <Grid item xs={8} sm={8}>
                                                                <Typography className="productName">{product?.name}</Typography>
                                                                <Typography className="productDesc">{product?.description}</Typography>
                                                                <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start" pt={1} flexWrap="nowrap">
                                                                    {/* Food Type Icons */}
                                                                    {product?.foodType === 'VEG/VEGAN' ? (
                                                                        <Stack direction="row" spacing={0.5} alignItems="center" flexShrink={0}>
                                                                            <img
                                                                                className="veg-nonveg"
                                                                                src={Images.veg}
                                                                                alt="veg"
                                                                                style={{ height: 24, width: 24 }}
                                                                            />
                                                                            <img
                                                                                className="veg-nonveg"
                                                                                src={Images.vegan}
                                                                                alt="vegan"
                                                                                style={{ height: 24, width: 24 }}
                                                                            />
                                                                        </Stack>
                                                                    ) : (
                                                                        <img
                                                                            className="veg-nonveg"
                                                                            src={
                                                                                product?.foodType === 'VEG'
                                                                                    ? Images.veg
                                                                                    : product?.foodType === 'VEGAN'
                                                                                        ? Images.vegan
                                                                                        : Images.nonVeg
                                                                            }
                                                                            alt={product?.foodType?.toLowerCase()}
                                                                            style={{ height: 24, width: 24 }}
                                                                        />
                                                                    )}

                                                                    {/* Calories & Weight */}
                                                                    <Stack direction="row" spacing={1} alignItems="center" flexWrap="nowrap">
                                                                        <Typography color="#6B6C6E" noWrap>{product?.calories} Kcal</Typography>
                                                                        <Box sx={{ width: '1px', height: '16px', backgroundColor: '#6B6C6E' }} />
                                                                        <Typography color="#6B6C6E" noWrap>
                                                                            {product?.weight}
                                                                            {product?.weightUnit}
                                                                        </Typography>
                                                                    </Stack>
                                                                </Stack>

                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Grid>
                                            </>);
                                    })}
                            </Grid>
                        )
                    })}
                </Grid>
            </Box>

            <Drawer open={Boolean(selectedProduct)} onClose={handleCloseModal} anchor="bottom">
                <Box className="productDrawer">
                    <IconButton
                        onClick={handleCloseModal}
                        sx={{
                            position: 'absolute',
                            top: -20,
                            right: 8,
                            zIndex: 1,
                            backgroundColor: '#fff',
                            height: 16,
                            width: 16,
                        }}
                    >
                        <CloseOutlined sx={{ fontSize: 12 }} />
                    </IconButton>

                    <Grid container>
                        <Grid item xs={5} sx={{ justifyContent: 'center' }}>
                            <Box className="imageBox">
                                <img
                                    className="image"
                                    src={
                                        selectedProduct?.displayImageUrl ||
                                        selectedProduct?.displayImage ||
                                        selectedProduct?.coverPicture
                                    }
                                    alt="Product"
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={7} sx={{ pl: '2%' }}>
                            <Box className="productDetails">
                                <Typography className="productName">{selectedProduct?.name}</Typography>
                                <Typography className="productInfo">{selectedProduct?.description}</Typography>

                                {/* food-type & kcal / weight */}
                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                    {/* icons */}
                                    {selectedProduct?.foodType === 'VEG/VEGAN' ? (
                                        <Stack direction="row" spacing={0.5} alignItems="center" flexShrink={0}>
                                            <img className="vegNonveg" src={Images.veg} alt="veg" style={{ height: 20 }} />
                                            <img className="vegNonveg" src={Images.vegan} alt="vegan" style={{ height: 20 }} />
                                        </Stack>
                                    ) : (
                                        <img
                                            className="vegNonveg"
                                            src={
                                                selectedProduct?.foodType === 'VEG'
                                                    ? Images.veg
                                                    : selectedProduct?.foodType === 'VEGAN'
                                                        ? Images.vegan
                                                        : Images.nonVeg
                                            }
                                            alt={selectedProduct?.foodType?.toLowerCase()}
                                            style={{ height: 20 }}
                                        />
                                    )}

                                    <Typography sx={{ color: '#6B6C6E', pl: 1 }}>
                                        {selectedProduct?.calories} Kcal
                                    </Typography>

                                    <Box sx={{ mx: 1, width: 1.5, height: 20, bgcolor: '#6B6C6E' }} />

                                    <Typography sx={{ color: '#6B6C6E' }}>
                                        {selectedProduct?.weight} {selectedProduct?.weightUnit}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>

                    {selectedProduct && (
                        <>
                            {selectedProduct?.hasAddon && selectedProduct?.addons && selectedProduct?.addons?.length > 0 && (
                                <Box className="addonsBox">
                                    {selectedProduct?.addons
                                        .filter((addon) => !addon?.excludedOutlets?.includes(outletData?._id))
                                        .map((addon) =>
                                            addon?.values?.some((val) => val?.status !== 'INACTIVE' && !val?.excludedOutlets?.includes(outletData?._id)
                                            ) && (
                                                <Grid container key={addon._id} sx={{ padding: '10px 10px 7px 10px', backgroundColor: '#fff', marginBottom: '10px', borderRadius: '18px' }}>
                                                    <Grid item xs={3} sx={{ display: 'flex', paddingTop: '10px', alignItems: addon?.badgeImage ? 'center' : 'normal' }}>
                                                        {addon?.badgeImage &&
                                                            <img style={{ width: '40%', paddingRight: '10px' }} src={addon?.badgeImage} />
                                                        }
                                                        <Typography className="addonTitle">{addon?.title}</Typography>
                                                    </Grid>
                                                    <Grid item xs={9}>
                                                        {addon?.values?.some(v => v?.selectedImage || v?.nonSelectedImage) ? (
                                                            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                                                                    {addon?.values
                                                                        // .filter((addon) => addon?.status !== 'INACTIVE' && !addon?.iconInfo)
                                                                        // .filter((addon) => !addon?.excludedOutlets?.includes(outletData?._id))
                                                                        // .filter((addon) => (!addon?.iconInfo) && (addon?.status !== 'INACTIVE' || addon?.isDefault))
                                                                        // .filter((addon) => !addon?.excludedOutlets?.includes(outletData?._id) || addon?.isDefault)
                                                                        .filter((addon) =>
                                                                            (!addon?.iconInfo) &&
                                                                            (addon?.status !== 'INACTIVE' || addon?.isDefault) &&
                                                                            (!addon?.excludedOutlets?.includes(outletData?._id) || addon?.isDefault)
                                                                        )
                                                                        .map((addonValue) => {
                                                                            const isSelected = addon?.isMultipleSelect ? Array.isArray(selectedAddons[addon?._id]) && selectedAddons[addon?._id].some((selected) => selected?._id === addonValue?._id) : selectedAddons[addon?._id]?._id === addonValue?._id;
                                                                            const isDefault = addonValue?.isDefault;

                                                                            const isExcluded = addonValue?.excludedOutlets?.includes(outletData?._id);
                                                                            const isDisabled = isExcluded;

                                                                            const hasExplicitSelection = addon?.isMultipleSelect
                                                                                ? Array.isArray(selectedAddons[addon?._id]) &&
                                                                                selectedAddons[addon?._id].length > 0
                                                                                : !!selectedAddons[addon?._id];

                                                                            const showSelectedImage = isSelected || (!hasExplicitSelection && addonValue?.isDefault);

                                                                            return (
                                                                                <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                                                                                    <img
                                                                                        key={addonValue?._id}
                                                                                        onClick={() =>
                                                                                            handleAddonSelect(
                                                                                                addon._id,
                                                                                                {
                                                                                                    ...addonValue,
                                                                                                    offerPrice: addonValue?.price ?? 0,
                                                                                                    mrp: addonValue?.price ?? 0,
                                                                                                },
                                                                                                addon?.isMultipleSelect
                                                                                            )
                                                                                        }
                                                                                        src={showSelectedImage ? addonValue?.selectedImage : addonValue?.nonSelectedImage}
                                                                                        alt={addonValue?.value}
                                                                                        style={{
                                                                                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                                                            filter: isDisabled ? 'grayscale(100%) opacity(0.6)' : 'none',
                                                                                        }}
                                                                                    />
                                                                                    <Typography className="addonValue" sx={{ color: '#00A4E2' }}>
                                                                                        {addonValue?.subLabel}
                                                                                    </Typography>
                                                                                </Box>
                                                                            );
                                                                        })}
                                                                </Box>
                                                            </Box>
                                                        ) : (
                                                            <Stack spacing={1}>
                                                                {addon?.values
                                                                    .filter((addon) =>
                                                                        (!addon?.iconInfo) &&
                                                                        (addon?.status !== 'INACTIVE' || addon?.isDefault) &&
                                                                        (!addon?.excludedOutlets?.includes(outletData?._id) || addon?.isDefault)
                                                                    )
                                                                    // .filter((addon) => addon?.status !== 'INACTIVE' && !addon?.iconInfo)
                                                                    // .filter((addon) => !addon?.excludedOutlets?.includes(outletData?._id))
                                                                    // .filter((addon) =>
                                                                    //   addon?.status !== 'INACTIVE' &&
                                                                    //   !addon?.iconInfo &&
                                                                    //   (!addon?.excludedOutlets?.includes(outletData?._id) || addon?.isDefault)
                                                                    // )
                                                                    .map((addonValue) => {

                                                                        const isSelected = addon?.isMultipleSelect
                                                                            ? Array.isArray(selectedAddons[addon?._id]) &&
                                                                            selectedAddons[addon?._id].some(s => s._id === addonValue?._id)
                                                                            : selectedAddons[addon?._id]?._id === addonValue?._id;

                                                                        const hasExplicitSelection = addon?.isMultipleSelect
                                                                            ? Array.isArray(selectedAddons[addon._id]) &&
                                                                            selectedAddons[addon?._id].length > 0
                                                                            : Boolean(selectedAddons[addon?._id]);

                                                                        const isDefault = addonValue?.isDefault;
                                                                        // exactly the same default‐logic as your image layout:
                                                                        const showSelected = isSelected || (!hasExplicitSelection && isDefault);

                                                                        // const isExcluded = addonValue?.excludedOutlets?.includes(outletData?._id);
                                                                        // const isDisabled = isExcluded;

                                                                        const isExcluded = addonValue?.excludedOutlets?.includes(outletData?._id);
                                                                        const isInactiveDefault = addonValue?.isDefault && addonValue?.status === 'INACTIVE';
                                                                        const isDisabled = isExcluded || isInactiveDefault;

                                                                        return (
                                                                            <Box
                                                                                key={addonValue?._id}
                                                                                className="addonItem"
                                                                                onClick={() => {
                                                                                    // if (isDisabled) return;
                                                                                    if (isDisabled) {
                                                                                        if (isInactiveDefault) {
                                                                                            toast.error('This default addon is currently unavailable.');
                                                                                        } else if (isExcluded) {
                                                                                            toast.error('This addon is not available at this outlet.');
                                                                                        }
                                                                                        return;
                                                                                    }
                                                                                    handleAddonSelect(addon?._id, {
                                                                                        ...addonValue,
                                                                                        offerPrice: addonValue?.price ?? 0,
                                                                                        mrp: addonValue?.price ?? 0,
                                                                                    }, addon?.isMultipleSelect)
                                                                                }}
                                                                                sx={{
                                                                                    display: 'flex',
                                                                                    flexDirection: 'column',
                                                                                    alignItems: 'flex-end',
                                                                                    padding: '4px 0',
                                                                                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                                                    opacity: isDisabled ? 0.6 : 1,
                                                                                    filter: isDisabled ? 'grayscale(100%) opacity(0.6)' : 'none'
                                                                                }}
                                                                            >
                                                                                <Typography className="addonValue" sx={{ color: '#00A4E2', cursor: isDisabled ? 'not-allowed' : 'pointer' }}>
                                                                                    {addonValue?.subLabel}
                                                                                </Typography>
                                                                                <Box className={`addonSelect ${(isSelected || showSelected) ? 'selected' : 'unselected'}`}>
                                                                                    {addonValue?.label ?? 0}
                                                                                    {/* <span style={{ paddingLeft: '7px' }}>+₹{addonValue?.price ?? 0}</span> */}
                                                                                </Box>
                                                                            </Box>
                                                                        );
                                                                    })}
                                                            </Stack>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            )
                                        )}
                                </Box>
                            )}
                        </>
                    )}

                    <Box display="flex" alignItems="center" justifyContent="center">
                        {showLimitModal ? (
                            <Box className="" px={2} position={'relative'}>
                                {showLimitModal && (
                                    <img style={{ position: 'absolute', top: 25, left: '50%', transform: 'translateX(-50%) translateY(-70%)', zIndex: 999 }} src={Images.subLimit} alt="Subscription Limit Reached" />
                                )}
                                <Box
                                    className='subLimitBtn'
                                    backgroundColor="#969696"
                                    padding={'10px 60px 10px 60px'}
                                    borderRadius={'50px'}
                                    color={'#fff'}
                                    my={2}
                                    position={'relative'}
                                >
                                    Can't add more to cart
                                </Box>
                            </Box>
                        ) : (
                            <Box className="priceAndButton" px={2} >
                                {addingToCart ? (
                                    <Box className="d-button" sx={{ mx: 'auto' }}>
                                        <CircularProgress size={18} sx={{ color: '#fff', mr: 1 }} />
                                        Adding to cart
                                    </Box>
                                ) : (
                                    <Box
                                        className={selectedProduct?.isExhausted ? 'exhaustedButton' : 'd-button'}
                                        sx={{ mx: 'auto' }}
                                        onClick={() => {
                                            if (selectedProduct?.isExhausted) return;
                                            if (!validateAddonsBeforeAddToCart()) return;
                                            addToLocalCart(selectedProduct);
                                        }}
                                    >
                                        {selectedProduct?.isExhausted ? 'Out Of Stock' : 'Add item'}
                                    </Box>
                                )}
                            </Box>
                        )}
                    </Box>

                </Box>
            </Drawer>

            {localCart.length > 0 && (
                <Box sx={{ position: 'relative' }}>
                    <Box className="floatingCartSub" onClick={() => navigate('/subscriptionCart', { state: { sub } })} sx={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 1 }} >

                        {showLimitModal && (
                            <img style={{ position: 'absolute', top: -6, left: 50, zIndex: 999 }} src={Images.subLimit} alt="Subscription Limit Reached" />
                        )}
                        <Box sx={{ pl: 4 }}>
                            <Typography>
                                {localCart.reduce((sum, item) => sum + (item.quantity || 1), 0)}{' '}
                                {localCart.reduce((sum, item) => sum + (item.quantity || 1), 0) === 1 ? 'Item' : 'Items'}
                            </Typography>
                        </Box>
                        <Box display="flex" flexDirection="row" justifyContent={'space-around'} sx={{ backgroundColor: '#FFFFFF', borderRadius: '40px', py: '5px', px: 2 }}>
                            <Box display="flex" flexDirection="row" alignItems="center">
                                <ShoppingCartOutlined sx={{ fontSize: 18, color: '#09A5F7', pr: 0.5 }} />
                                <Typography color="#0E4961">Cart</Typography>
                            </Box>
                            <KeyboardArrowRight sx={{ color: '#0E4961' }} />
                        </Box>
                    </Box>
                </Box>
            )}

        </Box>
    )
}

export default SubscriptionMenu;
